<template>
  <div class="home">
    <FanForm />
  </div>
</template>

<script>
// @ is an alias to /src
import FanForm from "@/components/FanForm.vue";

export default {
  name: "HomeView",
  components: {
    FanForm,
  },
};
</script>
